/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import './roomDisplayToggle.css';

export default (props) => { 
	return (
 	<div className="checkBox">
	 	<input className="roomToggleInput" onChange={props.onChange} type='checkbox' title="Show Inactive Rooms" name='roomDisplayToggle' value='roomDisplayToggle' />Show Inactive Rooms
		</div>
	);
};




// WEBPACK FOOTER //
// ./src/Components/Filters/RoomDisplayToggle/roomDisplayToggle.js